import React from "react";
import DoubleContent from "../../../../components/common/DoubleContent";

const CondicoesGerais = () => {
  return (
    <DoubleContent
      collumnSize={5}
      leftContent={<div>Teste Esquerda</div>}
      rightContent={<div>Teste Direita</div>}
    />
  );
};

CondicoesGerais.propTypes = {};

export default CondicoesGerais;
